import { render, staticRenderFns } from "./uklon_image_tab.vue?vue&type=template&id=4df96ec4&scoped=true&"
import script from "./uklon_image_tab.vue?vue&type=script&lang=js&"
export * from "./uklon_image_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df96ec4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4df96ec4')) {
      api.createRecord('4df96ec4', component.options)
    } else {
      api.reload('4df96ec4', component.options)
    }
    module.hot.accept("./uklon_image_tab.vue?vue&type=template&id=4df96ec4&scoped=true&", function () {
      api.rerender('4df96ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/uklon/location/tabs/uklon_image_tab.vue"
export default component.exports